import { useEffect } from 'react'
import type { StoryClock } from '../application/ports'
import { engagementApi } from '../infrastructure/engagement-api'
export function useMarketingOffers(account: string, clock: StoryClock) {
  const offers = engagementApi.useMarketingOffersQuery(account, {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: 60,
  })
  const { currentData, refetch } = offers
  useEffect(() => {
    const ends = (currentData?.value ?? [])
      .map((item) => item.endsAt)
      .filter((end) => end > clock.now())
    if (!ends.length) return
    return clock.schedule(
      () => {
        void refetch()
      },
      Math.min(...ends) - clock.now() + 1,
    )
  }, [currentData, refetch, clock])
  return offers
}
